import { FlatList } from 'react-native'
import styles from './styles'
import GeneItemList from './GeneItemList'
import { i18n } from '$localization/config.js'

function GenesView({ genes }) {
  const positiveGenesData = genes.filter(
    (gene) => gene.result !== 'n' && gene.result !== 'ln'
  )
  const userHasAnyPositiveGenes = positiveGenesData?.length > 0
  const hasNegativeGeneticTestingResults = genes.some(
    (gene) => gene.result === 'n' || gene.result === 'ln'
  )

  const negativeResult = {
    umls_name: i18n.t('negative_genetic_testing.default'),
    result: 'n',
  }

  return (
    <FlatList
      style={styles.genesViewContainer}
      data={
        userHasAnyPositiveGenes
          ? positiveGenesData
          : hasNegativeGeneticTestingResults && [negativeResult]
      }
      renderItem={({ item }) => <GeneItemList item={item} />}
      keyExtractor={(item) => item.umls_name}
    />
  )
}

export default GenesView
